import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Button, H1, P, Spinner, PRE_QUALIFICATION_ACCEPT_DECLINED_URL, PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY_URL, useNewTab, } from 'shared';
import { useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery } from 'consumer-applications-v2-api';
import { toastError } from 'utils';
import { setActiveOfferId, setOfferScreen, setPrequalification, } from '../actions';
import { selectors } from '../reducer';
function ImprintIDV({ offer }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const personalInfo = useSelector(selectors.personalInfo);
    const prequalification = useSelector(selectors.prequalification);
    const handleRefreshOffer = useCallback(async () => {
        const res = await getCreditApplicationsByStatus({
            applicationId: prequalification?.applicationId,
        });
        if ('data' in res) {
            const { data } = res;
            const imprintOffer = data?.offers?.find((offer) => offer.serviceProviderName === 'Imprint');
            const otherOffers = data?.offers?.filter((offer) => offer.serviceProviderName !== 'Imprint' &&
                offer.offerType === 'prequalified');
            if (data?.applicationStatus === 'not_prequalified') {
                if (imprintOffer) {
                    history.push({
                        pathname: PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY_URL,
                        state: { email: personalInfo.email, aanUrl: imprintOffer.aanUrl },
                    });
                }
                else {
                    history.push(PRE_QUALIFICATION_ACCEPT_DECLINED_URL);
                }
                return;
            }
            if (imprintOffer && imprintOffer.offerType !== 'step_up_pend') {
                dispatch(setPrequalification(data));
                dispatch(setActiveOfferId(imprintOffer.offerId));
                if (otherOffers && otherOffers.length > 0) {
                    dispatch(setOfferScreen('OTHER OFFERS'));
                }
                else {
                    dispatch(setOfferScreen('PRESENTED OFFER'));
                }
            }
            else {
                toastError('Application status is still pending identity verification.');
            }
        }
    }, [dispatch, history, personalInfo.email, prequalification?.applicationId]);
    const { setNewTab, isAwaitingClose } = useNewTab(handleRefreshOffer);
    const [getCreditApplicationsByStatus, { isFetching }] = useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery();
    const handleCompleteVerification = () => {
        const imprintIDVTab = window.open(offer.actionDetails?.url);
        imprintIDVTab && setNewTab(imprintIDVTab);
    };
    return (_jsxs("div", { children: [_jsx(H1, { children: "You're almost done! We need additional information to generate your offer." }), _jsxs(P, { variant: "title-large", className: "mar-t-24", children: ["Please click COMPLETE VERIFICATION below in order to provide a US-government issued photo ID and selfie to complete the verification.", ' '] }), _jsx(Button, { className: "button-warn-advantage mar-t-24 complete-verification", type: "button", onClick: handleCompleteVerification, submitting: isAwaitingClose || isFetching, invalid: isAwaitingClose || isFetching, children: "COMPLETE VERIFICATION" }), _jsx(P, { variant: "title-large", className: "mar-t-24", children: "After successfully verifying your identity, you will be able to view your Alphaeon Advantage offer and continue with the pre-qualification process." }), _jsxs("div", { className: "d-flex align-center mar-t-24", children: [_jsxs(P, { variant: "title-large", className: "mar-right-10", children: ["Already completed the verification process?", ' '] }), !isFetching ? (_jsx(P, { variant: "title-large", className: "text-as-link bold", onClick: () => {
                            !isFetching && handleRefreshOffer();
                        }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter' && !isFetching) {
                                handleRefreshOffer();
                            }
                        }, children: "Click here to refresh your offer." })) : (_jsx(Spinner, { size: "small" }))] })] }));
}
export default ImprintIDV;
